import axios from "axios";

export async function getPresignedS3Url(file, width, height) {
	let token = localStorage.getItem("jwt");
    let siteId = localStorage.getItem("siteId");

	var urlS3 = `${process.env.ROOT_API}/api/site/${siteId}/file/upload/link`;

	// faz o tratamento das variaveis que sao necessarias na url para nao passar variavel vazia na api
	if (!file) {
		return null;
	}

	urlS3 += `?`;
	urlS3 += `filename=${file.name}`;
	urlS3 += `&type=${file.meta.type}` ;
	urlS3 += `&extension=${file.extension}`;
	urlS3 += `&contenttype=${file.meta.type}`;
	urlS3 += `&size=${file.progress.bytesTotal}`;
	urlS3 += `&width=${width}`;
	urlS3 += `&height=${height}`;

	try {
		let response = await axios({
			url: urlS3,
			method: "get",
			headers: {
				Authorization: "Bearer " + token
			},
		});

		return response;
	} catch (error) {
		console.log(error);
	}
}

export default {
	methods: {
		requestApiData(url, type, data = '') {
			let token = this.$session.get("jwt");
			return new Promise(resolve => {
				axios({
					method: type,
					url: `${process.env.ROOT_API}api${url}`,
					data: data,
					headers: {
						Authorization: "Bearer " + token
						// 'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(response => {
					resolve(response.data)
				}).catch(error => {
					resolve(error)
				})
			});
		},
		async loadSitePosts(siteId, categoryId = null) {
            const url = categoryId
				? `/site/${siteId}/dashboard/posts?reference=${categoryId}`
            	: `/site/${siteId}/dashboard/posts`;
				
			const data = await this.requestApiData(url, 'get');
				
			return data.count ? data.data : [];
        },
		validateTokenRequest(url, data) {
			return new Promise(resolve => {
				axios({
					method: 'post',
					url: `${process.env.ROOT_API}api${url}`,
					data: data,
					config: { headers: { "Content-Type": "multipart/form-data" } },
				}).then(response => {
					resolve(response.data)
				}).catch(error => {
					resolve(error)
				})
			})
		},
		getSiteMedias(siteId) {
			let token = this.$session.get("jwt");
			return new Promise(resolve => {
				axios({
					method: "get",
					url: `${process.env.ROOT_API}api/site/${siteId}/image/list`,
					data: "",
					headers: {
						Authorization: "Bearer " + token
						// 'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
					.then(response => {
						if (response.data.status == 1) {
							resolve(response.data.content);
						} else {
							resolve([]);
						}
					})
					.catch(response => {
						console.log("Falha buscar imagens");
						console.log(response);
					});
			});
		},
		async deleteMedias(files) {
			let token = this.$session.get("jwt");
			let siteId = this.$session.get("siteId");
			
			// foi utilizado o try, catch para que o erro nao seja tratado no axios, e sim no componente que esta chamando a funcao
			try {
				const response = await axios({
					method: "post",
					url: `${process.env.ROOT_API}api/site/${siteId}/file/delete`,
					data: {'files': files},
					headers: {
						Authorization: "Bearer " + token,
					}
				});

				if (response.status == 200) {
					return true;
				}

				return false;
			} catch (error) {
				console.log(error);

				return false;
			}
		},
		async fetchFrameVariables() {
            const response = await this.requestApiData(
                '/frames/variables',
                'get'
            );
            
            if (response.success) { return response.data; }
        },
		async fetchTemplateOrganismsCombinations() {
			const response = await this.requestApiData(
				'/template/organism/combination',
				'get'
			);

			if (response.success) { return response.message; }
		},
		async fetchSections() {
			const response = await this.requestApiData(
				'/frame/organism/combination?filters=active:=:1',
				'get'
			);

			if (response.status) { return response.data; }
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/apiMixins.js